import React from "react";
import "./TopPerformerCard.css";

const TopPerformerCard = ({ title, image, name }) => {
  return (
    <div className="top-performer-card">
      <div className="top-performer-image-wrapper">
        <img src={image} alt={title} className="top-performer-image" />
        <div className="top-performer-text">
          <div className="top-performer-info">
            <div className="top-performer-name">{name}</div>
            <div className="top-performer-title">{title}</div>
          </div>
          <div className="top-performer-underline"></div>
        </div>
      </div>
    </div>
  );
};

export default TopPerformerCard;
